import * as XLSX from "xlsx";
import { formatDateForFilename } from "../../scenes/Layers/fields/formatters";

export const generateExcelFileName = (baseName: string) => {
    return `export-${baseName}-${formatDateForFilename()}`;
};

export const exportData = (data: ArrayBuffer, fileName: string, type: string) => {
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
};

export const exportDataToExcel = (data: any, fileName: string, sheetName = "Sheet1", header) => {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data, header ? { header } : {});

    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    const excelBuffer: ArrayBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    exportData(excelBuffer, `${fileName}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
};

export const readDataFromExcelFile = (file: File): Promise<any[]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target?.result as ArrayBuffer);
                const workbook = XLSX.read(data, { type: "array" });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];

                let json: any[] = XLSX.utils.sheet_to_json(worksheet);

                json = json.filter((row) => Object.values(row).some((value) => value !== null
                        && value !== undefined
                        && String(value).trim() !== ""));

                resolve(json);
            } catch (err) {
                reject(err);
            }
        };

        reader.onerror = (err) => reject(err);
        reader.readAsArrayBuffer(file);
    });
};
